module.exports = __webpack_public_path__ + "9b44cf51cc532f86bf857b874822aec5.svg";